import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { Tabs } from "@perxis-auto/ui-kit/lib/components/Tabs";
import clsx from "clsx";
import styles from "./ComparisonEquipments.module.scss.js";
const ComparisonEquipments = memo(function ComparisonEquipments2({
  items,
  className,
  ...props
}) {
  const isHidden = !(items == null ? void 0 : items.length);
  if (isHidden) {
    return null;
  }
  return /* @__PURE__ */ jsx(Tabs, { destroyInactiveTabPane: true, items, className: clsx(styles.comparisonEquipments, className), ...props });
});
export {
  ComparisonEquipments
};
